var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ResponseError = (function (_super) {
    __extends(ResponseError, _super);
    function ResponseError(data, msg) {
        var _this = _super.call(this, msg) || this;
        _this.resData = data;
        return _this;
    }
    return ResponseError;
}(Error));
export { ResponseError };
export default ResponseError;
